import React from "react";
import { useBrand } from "../../../context/BrandContext";

interface modalProps {
  isBloc?: boolean;
}

const Loading: React.FC<modalProps> = ({ isBloc }) => {
  const { company } = useBrand();
  const isByzWash = company?.slug === "byzwash";

  return (
    <div
      className={`flex items-center justify-center h-screen space-x-2 ${
        isByzWash ? "bg-[#16301d]" : "bg-white"
      }`}
    >
      <span className="sr-only">Loading...</span>
      <div
        className="h-4 w-4 rounded-full animate-bounce [animation-delay:-0.3s]"
        style={{ background: "var(--color-primary)" }}
      ></div>
      <div
        className="h-4 w-4 rounded-full animate-bounce [animation-delay:-0.15s]"
        style={{ background: "var(--color-primary)" }}
      ></div>
      <div
        className="w-4 h-4 rounded-full animate-bounce"
        style={{ background: "var(--color-primary)" }}
      ></div>
    </div>
  );
};

export default Loading;
